import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { StudentRow } from './types';
import { sanitizeText } from './textInput';
import { Tooltip } from 'primereact/tooltip';

const COLUMNS = [
  { field: 'user_id', header: 'EMIS Id' },
  { field: 'name', header: 'Name' },
  { field: 'class_studying', header: 'Class' },
  { field: 'class_section', header: 'Section' },
  // { field: 'user', header: 'Users' },
];

interface Props {
  students: StudentRow[];
  onAddStudent: () => void;
  onEdit: (row: StudentRow) => void;
  onDelete: (row: StudentRow) => void;
}

const StudentListTable: React.FC<Props> = ({
  students,
  onAddStudent,
  onEdit,
  onDelete,
}) => {
  const [globalFilter, setGlobalFilter] = useState('');
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);

  return (
    <div className="card overflow-hidden student-table">
      <div className="card-body">
        <div className="d-flex justify-content-end align-items-center gap-2 mb-2">
          <input
            type="text"
            value={globalFilter}
            onChange={(e) => setGlobalFilter(sanitizeText(e.target.value))}
            placeholder="Search..."
            className="form-control w-auto"
          />
          <Button
            type="button"
            label="Add Student"
            icon="pi pi-plus"
            className="p-button-sm"
            onClick={onAddStudent}
          />
        </div>
        <Tooltip
          key={`${students.length}-${first}-${rows}-${globalFilter}`}
          target=".emis-badge"
        />
        <DataTable
          value={students}
          sortMode="single"
          size="small"
          stripedRows
          emptyMessage="No Records Found"
          globalFilter={globalFilter}
          globalFilterFields={COLUMNS.map((c) => c.field)}
          paginator
          first={first}
          rows={rows}
          onPage={(e) => {
            setFirst(e.first);
            setRows(e.rows);
          }}
          rowsPerPageOptions={[10, 25, 50, 100]}
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          responsiveLayout="scroll"
          className="prime-table"
        >
          <Column
            header="S.NO"
            body={(_r, { rowIndex }) => rowIndex + 1}
            style={{ width: '4em' }}
          />
          {COLUMNS.map((col) => (
            <Column
              key={col.field}
              field={col.field}
              header={col.header}
              body={
                col.field == 'user_id'
                  ? (row: StudentRow) => (
                      <span
                        className={`badge emis-badge ${
                          row.is_dump == 1 ? 'bg-primary' : 'bg-success'
                        }`}
                        // data-pr-tooltip={
                        //   row.is_dump == 1 ? 'Already Added ' : 'Newly Added'
                        // }
                        data-pr-position="top"
                      >
                        {row.user_id}
                      </span>
                    )
                  : undefined
              }
            />
          ))}
          <Column
            header="Exposure Visit"
            alignHeader="center"
            bodyClassName="text-center"
            style={{ minWidth: '14rem' }}
            body={(row: StudentRow) => {
              if (row.ExpotStatus == '1') {
                return (
                  <div className="d-flex flex-column align-items-center gap-1">
                    <span className="badge bg-success">Visited</span>
                    {(row.instititute_name && row.instititute_name !== 'Others'
                      ? row.instititute_name
                      : row.other_collage) && (
                      <small
                        className="text-muted text-center"
                        style={{ maxWidth: '16rem', lineHeight: 1.3 }}
                      >
                        {row.instititute_name &&
                        row.instititute_name !== 'Others'
                          ? row.instititute_name
                          : row.other_collage}
                      </small>
                    )}
                  </div>
                );
              }
              if (row.ExpotStatus == '2') {
                return <span className="badge bg-danger">NO</span>;
              }
              return <span>--</span>;
            }}
          />
          <Column
            header="Action"
            alignHeader="center"
            bodyClassName="text-center"
            body={(row: StudentRow) => (
              <div className="d-inline-flex align-items-center justify-content-center gap-2">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => onEdit(row)}
                >
                  <i className="pi pi-pencil" />
                </button>
                {/* {row.ExpotStatus == '1' && ( */}
                {/* <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => onDelete(row)}
                >
                  <i className="pi pi-trash" />
                </button> */}
                {/* )} */}
              </div>
            )}
            style={{ width: '8rem' }}
          />
        </DataTable>
      </div>
    </div>
  );
};

export default StudentListTable;
